import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation, useTranslation } from 'react-i18next';
import * as tcRenewalAction from 'features/tc-renewal/duck';
import * as locationActions from 'shared/ducks/locationDuck';
import { ReportingLocationModel } from 'shared/models';
import { AlertMessage, AlertNotice, SimpleModal } from 'shared/components';
import MaterialIcon from 'material-icons-react';
import { PermissionsService } from 'shared/services';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import EditReportingLocation from './EditReportingLocation';

import './TCReportingLocations.scss';

class TCReportingLocations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
      alertMessage: '',
      isDirty: false,
      locationForRemove: null,
      isError: false,
    };

    this.saveLocation = this.saveLocation.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.removeMessage = this.removeMessage.bind(this);
    this.cancelRemoveLocation = this.cancelRemoveLocation.bind(this);
    this.onRemoveLocation = this.onRemoveLocation.bind(this);
    this.checkIsDirty = this.checkIsDirty.bind(this);
  }

  componentDidMount() {
    const { locations } = this.props;

    if (!isEmpty(locations)) {
      this.setState({
        errors: {},
      });
    } else {
      this.props.disableContinueBtn(true);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.locations &&
      this.props.locations.length &&
      prevProps.locations !== this.props.locations
    ) {
      this.setState({
        locations: this.props.locations,
      });
    }
  }

  async saveLocation(location, idx) {
    const locations = [...this.props.locations];
    const { actions, tcCycle } = this.props;

    const newLocation = new ReportingLocationModel(location);
    newLocation.testCenterCycleId = tcCycle.id;

    const updatedLocation = await actions.updateLocation(newLocation);

    if (updatedLocation.id) {
      if (idx === undefined) {
        locations.push(updatedLocation);
        const cycleData = {
          ...tcCycle,
          locations,
        };
        actions.getTcCycleAction({ data: cycleData });
      } else {
        locations.splice(idx, 1, updatedLocation);
        const cycleData = {
          ...tcCycle,
          locations,
        };
        actions.getTcCycleAction({ data: cycleData });
      }
      this.setState({
        error: '',
        showMessage: true,
        showMessageTime: 3000,
        alertMessage:
          idx !== undefined
            ? 'testCenter.reportingLocations.editLocationSuccessMessage'
            : 'testCenter.reportingLocations.addLocationSuccessMessage',
        isError: false,
      });

      this.props.disableContinueBtn(false);
    } else {
      this.setState({
        error: '',
        showMessage: true,
        showMessageTime: 3000,
        alertMessage: 'errors.saveError',
        isError: true,
      });
    }
  }

  async onRemoveLocation() {
    const { locationForRemove } = this.state;
    const { tcCycle, actions } = this.props;
    const locations = [...this.props.locations];

    const removeLocation = locations[locationForRemove];
    const deleted = await actions.deleteLocation(removeLocation);

    if (deleted.message) {
      this.setState({
        error: '',
        locationForRemove: null,
        showMessage: true,
        showMessageTime: 3000,
        alertMessage: 'errors.saveError',
        isError: true,
      });
    } else {
      locations.splice(locationForRemove, 1);
      const cycleData = {
        ...tcCycle,
        locations,
      };
      this.setState({
        locationForRemove: null,
        showMessage: true,
        showMessageTime: 3000,
        alertMessage: 'testCenter.reportingLocations.removeLocationSuccessMessage',
        isError: false,
      });
      actions.getTcCycleAction({ data: cycleData });

      if (isEmpty(locations)) {
        this.props.disableContinueBtn(true);
      }
    }
  }

  removeMessage() {
    this.setState({
      showMessage: false,
    });
  }

  cancelRemoveLocation() {
    this.setState({
      locationForRemove: null,
    });
  }

  async handleContinue() {
    const { locations } = this.props;

    if (!locations.length) {
      this.setState({
        error: 'errors.locationsRequired',
      });
      return;
    }

    this.props.actions.getTcCycleEvents(this.props.tcCycle.id);

    return true;
  }

  checkIsDirty() {
    return this.state.isDirty;
  }

  render() {
    const { locationForRemove } = this.state;
    const { tcCycle, locations } = this.props;
    const hasTestCenterManage = PermissionsService.hasTestCenterManage(tcCycle.id);

    return (
      <section>
        <h4>{this.props.t('testCenter.reportingLocations.title')}</h4>
        <p className="mb-30">
          {locations.length
            ? this.props.t('testCenter.reportingLocations.subtitleLocationsAdded')
            : this.props.t('testCenter.reportingLocations.subtitleNoLocations')}
        </p>
        {!locations.length && (
          <div>
            <h5>{this.props.t('testCenter.reportingLocations.noLocationsTitle')}</h5>
            <AlertNotice message={this.props.t('testCenter.reportingLocations.noLocationsInfo')} />
          </div>
        )}

        {hasTestCenterManage && (
          <EditReportingLocation
            location={new ReportingLocationModel({})}
            addNew
            institutionAddress={tcCycle.testCenterProgram.testCenter}
            onSave={this.saveLocation}
          />
        )}

        {locations && (
          <div className="reporting-locations">
            {locations.map((location, idx) => (
              <ReportingLocation
                location={location}
                institutionAddress={tcCycle.testCenterProgram.testCenter}
                saveLocation={(loc) => this.saveLocation(loc, idx)}
                testCenterName={tcCycle.testCenterProgram.testCenter.name}
                removeLocation={() => this.setState({ locationForRemove: idx })}
                key={idx}
              />
            ))}
          </div>
        )}

        {this.state.error && <span className="text-error">{this.props.t(this.state.error)}</span>}

        <AlertMessage
          show={!!this.state.showMessage}
          time={this.state.showMessageTime}
          removeMessage={this.removeMessage}
          message={this.state.alertMessage}
          isError={this.state.isError}
        />

        <SimpleModal
          isOpen={!isNull(locationForRemove) && !!locations.length}
          onCancel={this.cancelRemoveLocation}
          onConfirm={this.onRemoveLocation}
          confirmLabel={this.props.t('common.labels.yes')}
          cancelLabel={this.props.t('common.labels.no')}
          headline={this.props.t('staffManagement.removeConfirmationMessage', {
            list: !isNull(locationForRemove) ? `${locations[locationForRemove].name}` : '',
          })}
        />
      </section>
    );
  }
}

const ReportingLocation = (props) => {
  const { t } = useTranslation();
  return (
    <div className="reporting-location">
      <div className="reporting-location-info">
        <div className="reporting-test-center-name">{props.testCenterName}</div>
        <div className="reporting-location-name">{props.location.name}</div>
        <div>{props.location.area}</div>
        <div>
          <span>{props.location.address1}, </span>
          <span>{props.location.city}, </span>
          <span>{props.location.stateCode} </span>
          <span>{props.location.postalCode}</span>
        </div>
      </div>

      <div className="reporting-location-btns">
        <div className="d-none d-md-block">
          <EditReportingLocation
            location={props.location}
            institutionAddress={props.institutionAddress}
            onSave={props.saveLocation}
          />
        </div>
        <div className="d-none d-md-block">
          <button className="btn-link text-pacific-blue" onClick={props.removeLocation}>
            <MaterialIcon icon="delete" size="tiny" />
            {t('common.labels.remove')}
          </button>
        </div>

        <div className="dropdown d-md-none">
          <div className="btn-options" data-bs-toggle="dropdown">
            {t('common.labels.options')}
            <MaterialIcon icon="more_vert" size="small" />
          </div>
          <div className="dropdown-menu dropdown-menu-right">
            <EditReportingLocation
              location={props.location}
              institutionAddress={props.institutionAddress}
              onSave={props.saveLocation}
            />
            <button className="btn-link text-pacific-blue" onClick={props.removeLocation}>
              <MaterialIcon icon="delete" size="tiny" />
              {t('common.labels.remove')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ReportingLocation.propTypes = {
  location: PropTypes.shape({}).isRequired,
  institutionAddress: PropTypes.shape({}).isRequired,
  saveLocation: PropTypes.func.isRequired,
  removeLocation: PropTypes.func.isRequired,
  testCenterName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    tcCycle: state.tcRenewal.tcCycle,
    locations: state.tcRenewal.tcCycle.locations || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...tcRenewalAction, ...locationActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(withTranslation(null, { withRef: true })(TCReportingLocations));

TCReportingLocations.propTypes = {
  tcCycle: PropTypes.shape({
    id: PropTypes.number,
    testCenterProgram: PropTypes.shape({
      testCenter: PropTypes.object,
    }),
  }).isRequired,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  disableContinueBtn: PropTypes.func,
  actions: PropTypes.shape({
    getTcCycle: PropTypes.func,
    addLocation: PropTypes.func,
    updateLocation: PropTypes.func,
    removeLocation: PropTypes.func,
    getTcCycleEvents: PropTypes.func,
  }),
  t: PropTypes.func.isRequired,
};
